module.exports = __webpack_public_path__ + "img/style_model_preview_672.a17a7e3b.jpg";